import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

const { multimediaBaseUrl, playlistPath, apiUrl } = environment;

export type PlaylistItem = {
  type: 'video' | 'image';
  src: string;
  durationSec: number;
  muted?: boolean;
};

type PlaylistResponse = {
  items: PlaylistItem[];
};

@Injectable({
  providedIn: 'root'
})
export class MultimediaService {
  private httpClient = inject(HttpClient);

  async getPlaylist(): Promise<PlaylistItem[]> {
    const response = await firstValueFrom(
      this.httpClient.get<PlaylistResponse>(`${multimediaBaseUrl}/${playlistPath}`)
    );

    return response.items;
  }

  async getMultimediaDeSala(salaId: string): Promise<PlaylistItem[]> {
    return await firstValueFrom(
      this.httpClient.get<PlaylistItem[]>(`${apiUrl}/salas/${salaId}/publicidad`)
    );
  }
}
